import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-recommend-form__field" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-form__title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "最寄駅")
], -1)
const _hoisted_3 = { class: "p-recommend-form__group-1-field-set-2" }
const _hoisted_4 = { class: "p-recommend-form-type-wrap" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "p-recommend-form__field" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-form__title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "最寄駅～自宅")
], -1)
const _hoisted_8 = { class: "p-recommend-form__error-wrap" }
const _hoisted_9 = { class: "p-recommend-form__set-3" }
const _hoisted_10 = { class: "p-recommend-form__set-3__group-1" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "分", -1)
const _hoisted_12 = { class: "p-recommend-form__field" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-form__title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "住居区分")
], -1)

import InvalidMessage from '@/components/InvalidMessage.vue';
import ResumeSearch from '../components/ResumeSearch.vue';
import ResumeSelect from '../components/ResumeSelect.vue';
import ValidatableField from '@/components/ValidatableField.vue';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'StationInfoForm',
  setup(__props) {

const stationResetKey = ref(0);
const clearNearestStationId = () =>
{
    stationResetKey.value++;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(ResumeSearch, {
            name: "nearestStationId",
            label: "最寄駅",
            id: "stations",
            "reset-key": stationResetKey.value
          }, null, 8, ["reset-key"])
        ]),
        _createElementVNode("button", {
          onClick: _withModifiers(clearNearestStationId, ["prevent"]),
          class: "p-recommend-form__clear js-clear",
          type: "button"
        }, "クリア", 8, _hoisted_5)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createVNode(InvalidMessage, { name: `walkBusTime` })
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(ResumeSelect, {
          name: `walkBusFlg`,
          label: "選択",
          id: "walkBus",
          className: "p-recommend-form__select"
        }),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(ValidatableField, {
            class: "p-recommend-form__modal-input-2",
            id: "form-station-distance",
            type: "text",
            name: "walkBusTime",
            label: "最寄駅～自宅（時間）",
            placeholder: "0",
            rules: "numeric|max:3",
            maxlength: "3"
          }),
          _hoisted_11
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _createVNode(ResumeSelect, {
        name: `inhabitTypeId`,
        label: "選択",
        id: "inHabitType",
        className: "p-recommend-form__select"
      })
    ])
  ], 64))
}
}

})